export default __webpack_public_path__ + "static/media/Paladin's Baneblade.d173a41e.jpg";